/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="no-data-wrap" v-show="noDataShow">
        <img src="../../assets/img/common/no_result.png" width="240" height="140">
        <p class="no-ps">暂无记录</p>
    </div>
</template>
<script>
    export default {
        props:{
            noDataShow:{
                type: Boolean,
                default: false
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .no-data-wrap{
        padding-top:150px;
        text-align: center;
        .no-ps{
            margin-top:30px;
            font-size: 16px;
            color: $c_989;
            letter-spacing: -0.39px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/noData.vue